var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, state } from 'lit/decorators.js';
import { SettingsController } from '../../utils/SettingsController';
import { BaseComponent } from '../../utils/BaseComponent';
import { html, nothing } from 'lit';
let TransactionBadge = class TransactionBadge extends BaseComponent {
    constructor() {
        super(...arguments);
        this._settingListener = new SettingsController(this, this.requestUpdate.bind(this));
    }
    willUpdate(_changedProperties) {
        switch (window.trustSettings.brand) {
            case "blocket":
                // todo: ask Maia or Carl what to do here.
                this.badge = nothing;
                break;
            case 'finn':
                this.badge = html `<p class="w-fit yellow-bg py-2 px-6 rounded-4 ${this.classNames} detail">
          Fiks ferdig
        </p>`;
                break;
            default:
                this.badge = nothing;
        }
    }
    render() {
        if (!window.trustSettings)
            return nothing;
        return this.badge;
    }
};
__decorate([
    property()
], TransactionBadge.prototype, "classNames", void 0);
__decorate([
    state()
], TransactionBadge.prototype, "badge", void 0);
TransactionBadge = __decorate([
    customElement('trust-transactional-badge')
], TransactionBadge);
export { TransactionBadge };
//# sourceMappingURL=TrustTransactionBadge.js.map